import globalWindow from '@shared/core/globals';
import { useCallback, useEffect, useRef } from 'react';

export const useWaitForTimeout = () => {
  const timerRefs = useRef<{ rafId: number | undefined; timeoutId: number | undefined }>({
    rafId: undefined,
    timeoutId: undefined,
  });

  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      const timers = timerRefs.current;
      timers.rafId && globalWindow.cancelAnimationFrame?.(timers.rafId);
      globalWindow.clearTimeout(timers.timeoutId);
    };
  }, []);

  return useCallback((timeout: number, cb?: () => void) => {
    return new Promise<true | undefined>(resolve => {
      timerRefs.current.rafId = globalWindow.requestAnimationFrame?.(() => {
        timerRefs.current.timeoutId = globalWindow.setTimeout(() => {
          cb?.();
          resolve(true);
        }, timeout);
      });
    });
  }, []);
};
